import Chart from "react-apexcharts";
import { Loading } from "../../../componentes/loading/loading";
import { reduzirNomeUnico } from "../../../utils/reduzirNome";

export function DesempenhoPorMontador({ report, loading }) {
    const nomes = Object.keys(report.caixasPorMontador || {});
    const montadores = Array.from(new Set([
        ...nomes,
        ...Object.keys(report.paletesPorMontador || {})
    ]));

    const caixasPorMontador = montadores.map((n) => Number(report.caixasPorMontador?.[n] || 0));
    const paletesPorMontador = montadores.map((n) => Number(report.paletesPorMontador?.[n] || 0));

    const options = {
        chart: {
            type: "area",
            zoom: { enabled: false },
        },
        xaxis: {
            categories: reduzirNomeUnico(montadores),
            labels: {
                rotate: -45, // ou -90 para vertical
                rotateAlways: true,
                hideOverlappingLabels: false,
                trim: false,
                style: {
                    fontSize: "11px",
                },
                    offsetY: 5      
            }
        },

        grid: {
            padding: {
                right: 30,
            },
        },
        stroke: {
            curve: "smooth",
            width: 2,
        },
        fill: {
            type: "gradient",
            gradient: {
                shade: "light",
                type: "vertical",
                shadeIntensity: 0.5,
                opacityFrom: 0.6,
                opacityTo: 0.1,
                stops: [0, 90, 100],
            },
        },
        markers: {
            size: 4,
        },
        legend: {
            position: "bottom",
        },
        colors: ["#3B82F6", "#10B981", "#EF4444"],
    };

    const series = [
        { name: "Caixas", data: caixasPorMontador },
        { name: "Paletes", data: paletesPorMontador },
    ];

    return (
        <div >
            {!loading ? (
                <Chart options={options} series={series} type="area" height={310} />
            ) : (
                <Loading />
            )}
        </div>
    );
}